<template>
  <div :class="{ 'max-w-6xl mx-auto p-5 font-sans': !shortView }">
    <el-dialog v-model="newCustomerDialogVisiable"
               :title="t('views.customers.newCustomer')">
      <NewCustomerDialog @success="onCustomerCreater"></NewCustomerDialog>
    </el-dialog>

    <div v-if="!shortView" class="flex gap-3 mb-6">
      <div class="flex-1">
        <el-select
            clearable
            class="w-full"
            value-key="contactDisplayName"
            v-model="selectedCustomer"
            filterable
            remote
            reserve-keyword
            :placeholder="t('searchCustomer')"
            :remote-method="remoteSearch"
            :loading="loading"
        >
          <el-option
              v-for="option in customerOptions"
              :key="option.id"
              :label="option.name"
              :value="option"
          ></el-option>
        </el-select>
      </div>
      <button type="button"
          @click="
          () => {
            newCustomerDialogVisiable = true
          }
        "
          class="px-4 bg-gray-200 text-black rounded-md hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
      >
        {{ t('addCustomer') }}
      </button>
      <button type="button"
          @click="
          () => {
            $router.push($Route.CUSTOMERS_QUEUE_MONITOR)
          }
        "
          class="rounded-xl border border-input bg-input p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0"
      >
        <Icon icon="line-md:monitor-screenshot-twotone" width="24" height="24"/>
      </button>
    </div>

    <div class="flex flex-col md:flex-row gap-6">
      <!-- Active Queue -->
      <div class="flex-1 bg-gray-50 rounded-lg p-4 shadow-sm">
        <div
            class="flex items-center justify-between mb-1 text-gray-700 text-xl font-semibold">
          <h2>{{ t('activeQueue') }}</h2>
          <span>
            {{ activeCustomers.length }}
          </span>
        </div>
        <draggable
            v-model="activeCustomers"
            group="customers"
            item-key="id"
            class="min-h-[400px]"
            @end="saveQueue"
        >
          <template #item="{ element, index }">
            <div
                class="bg-white rounded-lg p-2 mb-2 shadow-sm flex flex-col gap-2 justify-between hover:shadow-md transition-shadow cursor-move"
                :class="{ 'bg-green-50': index == 0 }"
            >
              <div class="flex gap-2">
                <div class="flex-1 w-full">
                  <div class="flex items-center gap-2">
                    <div class="text-lg py-1 font-bold">
                      {{ index == 0 ? '' : `${index}.` }}
                      {{ element.customer?.name }}
                    </div>
                    <!-- <div v-if="useSettingsStore().getValue('customers_names_to_be_viewed') == 'full_name'" class="text-lg py-1 font-bold">
                      {{ index == 0 ? '' : `${index}.` }}
                      {{ element.customer?.name }}
                    </div>
                    <div v-if="useSettingsStore().getValue('customers_names_to_be_viewed') == 'only_first_two_names'" class="text-lg py-1 font-bold">
                      {{ index == 0 ? '' : `${index}.` }}
                      {{ String(element.customer?.name).split(" ").splice(0, 2).join(" ") }}
                    </div> -->
                    <span v-if="element.customer?.dateOfBirth && Number.parseInt(formatAge(element.customer?.dateOfBirth, true)) < 100" class="relative h-8 w-8 rounded-full bg-blue-950 font-bold text-white flex items-center justify-center">
                      <span class="absolute top-[55%] left-[50%] -translate-x-[50%] -translate-y-[50%]">{{formatAge(element.customer?.dateOfBirth, true)}}</span>
                    </span>
                  </div>
                  <div class="px-2 pb-2 flex gap-2 items-center">
                    <div v-for="i in element?.order?.orderItems"
                         class="bg-input border-input rounded-lg p-[6px]">
                      {{ i?.item?.name }}
                    </div>
                  </div>
                  <div v-if="editingCustomer?.id === element.id">
                  <textarea
                      v-model="editingCustomer.notes"
                      class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      @blur="saveNotes(element)"
                      @keyup.enter="saveNotes(element)"
                      ref="notesTextarea"
                      rows="3"
                  ></textarea>
                    <button type="button"
                        @click="saveNotes(element)"
                        class="px-3 py-1 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600"
                    >
                      {{ t('save') }}
                    </button>
                  </div>
                  <p
                      v-else
                      @click="startEditing(element)"
                      class="text-gray-600 cursor-pointer hover:bg-gray-100 p-2 rounded-md"
                  >
                    {{ element.notes || t('clickToAddNotes') }}
                  </p>
                </div>
                <div>
                  <p
                      class="text-end me-1 text-lg font-bold text-blue-500"
                  >
                    <TimeCounter :start-date="element.createdAt"/>
                  </p>
                  <AddExam v-if="!element.orderID" :queue="element"
                          :shortView="shortView"
                           @orderCreated="onOrderCreated"/>
                  <div v-else class="me-1">
                    <router-link :to="$Route.SALES_ORDERS_ORDER.replace(':id', element.order.id)" class="font-bold">#{{element.order.externalID}}</router-link>
                  </div>
                </div>
              </div>
              <div
                  class="relative flex items-center justify-between gap-2 ml-4">
                <div class="flex gap-2 justify-center grow">
                  <button type="button"
                      @click="addCustomer(element?.customer)"
                      class="px-3 py-1 bg-blue-300 text-black rounded-md hover:bg-blue-400 transition-colors"
                  >
                    {{ t('addToExam') }}
                  </button>
                  <button type="button"
                      @click="markOnHold(element)"
                      class="px-3 py-1 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 transition-colors"
                  >
                    {{ t('markOnHold') }}
                  </button>
                  <button
                      @click="markDone(element)"
                      class="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
                  >
                    {{ t('done') }}
                  </button>
                  <button type="button"
                      @click="addToGlassesList(element)"
                      v-if="useSettingsStore().getValue('show_glasses_screen_button_on_customers_page') == 'true'"
                      :disabled="!!element.glassesJobID"
                      class="px-3 py-1 bg-purple-200 text-purple-800 rounded-md hover:bg-purple-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ t('glassesList') }}
                  </button>
                </div>
                <p class="mt-1 mx-2 text-xs text-gray-400">
                  {{ t('added') }}: {{ formatTime(element.createdAt) }}
                </p>
              </div>
            </div>
          </template>
        </draggable>
      </div>

      <!-- On Hold Queue -->
      <div v-if="!shortView" class="flex-1 bg-gray-50 rounded-lg p-4 shadow-sm">
        <div
            class="flex items-center justify-between mb-1 text-gray-700 text-xl font-semibold">
          <h2>{{ t('onHold') }}</h2>
          <span>{{ onHoldCustomers.length }}</span>
        </div>
        <draggable
            v-model="onHoldCustomers"
            group="customers"
            item-key="id"
            class="min-h-[400px]"
            @end="saveQueue"
        >
          <template #item="{ element, index }">
            <div
                class="bg-yellow-50 rounded-lg p-2 mb-2 shadow-sm flex flex-col gap-2 justify-between hover:shadow-md transition-shadow cursor-move"
            >
              <div class="flex gap-2">
                <div class="flex-1 w-full">
                  <div class="flex items-center gap-2">
                    <div class="text-lg py-1 font-bold">
                      {{ index + 1 }}. {{ element.customer?.name }}
                    </div>
                    <!-- <div v-if="useSettingsStore().getValue('customers_names_to_be_viewed') == 'full_name'" class="text-lg py-1 font-bold">
                      {{ index + 1 }}. {{ element.customer?.name }}
                    </div> -->
                    <!-- <div v-if="useSettingsStore().getValue('customers_names_to_be_viewed') == 'only_first_two_names'" class="text-lg py-1 font-bold">
                      {{ index + 1 }}. {{ String(element.customer?.name).split(" ").splice(0, 2).join(" ") }}
                    </div> -->
                    <span v-if="element.customer?.dateOfBirth && Number.parseInt(formatAge(element.customer?.dateOfBirth, true)) < 100" class="relative h-8 w-8 rounded-full bg-blue-950 font-bold text-white flex items-center justify-center">
                      <span class="absolute top-[55%] left-[50%] -translate-x-[50%] -translate-y-[50%]">{{formatAge(element.customer?.dateOfBirth, true)}}</span>
                    </span>
                  </div>
                  <div class="px-2 pb-2 flex gap-2 items-center">
                    <div v-for="i in element?.order?.orderItems"
                         class="bg-input border-input rounded-lg p-[6px]">
                      {{ i?.item?.name }}
                    </div>
                  </div>
                  <div v-if="editingCustomer?.id === element.id">
                  <textarea
                      v-model="editingCustomer.notes"
                      class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      @blur="saveNotes(element)"
                      @keyup.enter="saveNotes(element)"
                      ref="notesTextarea"
                      rows="3"
                  ></textarea>
                    <button type="button"
                        @click="saveNotes(element)"
                        class="px-3 py-1 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600"
                    >
                      {{ t('save') }}
                    </button>
                  </div>
                  <p
                      v-else
                      @click="startEditing(element)"
                      class="text-gray-600 cursor-pointer hover:bg-gray-100 p-2 rounded-md"
                  >
                    {{ element.notes || t('clickToAddNotes') }}
                  </p>
                </div>
                <div>
                  <p
                      class="text-end me-1 text-lg font-bold text-blue-500"
                  >
                    <TimeCounter :start-date="element.createdAt"/>
                  </p>
                  <AddExam v-if="!element.orderID" :queue="element"
                           @orderCreated="onOrderCreated"/>
                  <div v-else class="me-1">
                    <router-link :to="$Route.SALES_ORDERS_ORDER.replace(':id', element.order.id)" class="font-bold">#{{element.order.externalID}}</router-link>
                  </div>
                </div>
              </div>
              <div
                  class="relative flex items-center justify-between gap-2 ml-4">
                <div class="flex gap-2 justify-center grow">
                  <button type="button"
                      @click="reactivate(element)"
                      class="px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                  >
                    {{ t('reactivate') }}
                  </button>
                  <button type="button"
                      @click="markDone(element)"
                      class="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
                  >
                    {{ t('done') }}
                  </button>
                  <button type="button"
                      @click="addToGlassesList(element)"
                      :disabled="!!element.glassesJobID"
                      class="px-3 py-1 bg-purple-200 text-purple-800 rounded-md hover:bg-purple-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ t('glassesList') }}
                  </button>
                </div>
                <p class="mt-1 mx-2 text-xs text-gray-400">
                  {{ t('added') }}: {{ formatTime(element.createdAt) }}
                </p>
              </div>
            </div>
          </template>
        </draggable>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, nextTick, onMounted, ref, watch} from 'vue'
import draggable from 'vuedraggable'
import {ElOption, ElSelect} from 'element-plus'
import {useI18n} from 'vue-i18n'
import Customer from '@/models/customer/Customer'
import {useHTTP} from '@/plugins/http'
import TimeCounter from '@/views/customers/TimeCounter.vue'
import {Icon} from '@iconify/vue'
import NewCustomerDialog from '@/dialogs/customer/NewCustomerDialog.vue'
import AddExam from "@/views/customers/AddExam.vue";
import {i18nOrderMessages, Order} from "@/models/sales/Order";
import {formatAge} from "@/utils/date";
import { useSettingsStore } from '@/stores/settingsStore'

export interface CustomerQueue {
  id: string
  customer?: Customer
  customerID: string
  userID: string
  notes: string
  createdAt: Date
  status: string
  position: number
  orderID?: string
  glassesJobID?: string
}

export default defineComponent({
  methods: {formatAge},
  components: {
    AddExam,
    NewCustomerDialog,
    TimeCounter,
    draggable,
    ElSelect,
    ElOption,
    Icon
  },
  emits: ['addCustomer'],
  props: {
    shortView: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {emit}) {
    const {t} = useI18n({
      messages: {
        en: {
          ...i18nOrderMessages.en,
          queueSystem: 'Customer Queue System',
          addCustomer: 'Add Customer',
          addToList: 'Add to list',
          customerName: 'Customer Name',
          notes: 'Notes',
          activeQueue: 'Active Queue',
          onHold: 'On Hold',
          clickToAddNotes: 'Click to add notes',
          added: 'Added',
          save: 'Save',
          markOnHold: 'On Hold',
          reactivate: 'Reactivate',
          done: 'Done',
          addToExam: 'Add to Exam',
          searchCustomer: 'Search for customer',
          glassesList: 'Glasses List'
        },
        ar: {
          ...i18nOrderMessages.ar,
          queueSystem: 'نظام قائمة انتظار العملاء',
          addCustomer: 'إضافة عميل',
          addToList: 'إضافة الى القائمة',
          customerName: 'اسم العميل',
          notes: 'ملاحظات',
          activeQueue: 'قائمة الانتظار النشطة',
          onHold: 'في الانتظار',
          clickToAddNotes: 'انقر لإضافة ملاحظات',
          added: 'تمت الإضافة',
          save: 'حفظ',
          markOnHold: 'تعليق',
          reactivate: 'إعادة تنشيط',
          done: 'تم',
          searchCustomer: 'البحث عن عميل',
          addToExam: 'إضافة الى الفحص',
          glassesList: 'قائمة النظارات'
        }
      }
    })
    const http = useHTTP()
    const activeCustomers = ref<CustomerQueue[]>([])
    const onHoldCustomers = ref<CustomerQueue[]>([])
    const editingCustomer = ref<CustomerQueue | null>(null)
    const notesTextarea = ref<HTMLTextAreaElement | null>(null)

    // Element Plus remote search
    const loading = ref(false)
    const newCustomerDialogVisiable = ref(false)
    const customerOptions = ref<Customer[]>([])
    const selectedCustomer = ref<Customer | null>(null)

    async function load() {
      try {
        const queueData = await http.get<Array<CustomerQueue>>('/customer/queue')

        // Split customers into active and on-hold based on status
        activeCustomers.value = queueData
            .filter((c: any) => c.status === 'active')
            .map((customer: any) => ({
              ...customer,
              createdAt: new Date(customer.createdAt)
            }))

        onHoldCustomers.value = queueData
            .filter((c: any) => c.status === 'on-hold')
            .map((customer: any) => ({
              ...customer,
              createdAt: new Date(customer.createdAt)
            }))
      } catch (error) {
        console.error('Error loading queue:', error)
      }
    }

    // Load queue from backend API on component mount
    onMounted(async () => {
      load();
    })

    // Remote search method for customer dropdown
    const remoteSearch = async (query: string) => {
      if (!query) {
        query = ''
      }
      try {
        loading.value = true
        const url = `${Customer.ENDPOINT}?q=${query}`
        const customersRes = await http.get<Customer[]>(url)
        customerOptions.value = customersRes.map((customer) => Customer.from(customer))
      } catch (error) {
        console.error('Error searching customers:', error)
        customerOptions.value = []
      } finally {
        loading.value = false
      }
    }

    // Save queue state to backend
    const saveQueue = async (): Promise<boolean> => {
      try {
        // Create maps to track original positions and statuses before updating
        const originalPositions = new Map<string, number>()
        const originalStatuses = new Map<string, string>()

            // Store original positions and statuses before updating
        ;[...activeCustomers.value, ...onHoldCustomers.value].forEach((customer) => {
          originalPositions.set(customer.id, customer.position)
          originalStatuses.set(customer.id, customer.status)
        })

        // Always update all active customers to ensure position changes are saved
        const activeWithPositions = activeCustomers.value.map((customer, index) => ({
          ...customer,
          status: 'active',
          position: index
        }))

        // Update on-hold customers with new positions
        const onHoldWithPositions = onHoldCustomers.value.map((customer, index) => ({
          ...customer,
          status: 'on-hold',
          position: activeCustomers.value.length + index
        }))

        const allCustomers = [...activeWithPositions, ...onHoldWithPositions]

        // Update all customers in the active queue to ensure positions are correct
        const updatePromises = allCustomers
            .filter((customer) => {
              const originalPosition = originalPositions.get(customer.id)
              const originalStatus = originalStatuses.get(customer.id)

              // Always update active customers and any customers that changed status
              return (
                  customer.status === 'active' ||
                  originalPosition !== customer.position ||
                  originalStatus !== customer.status
              )
            })
            .map((customer) =>
                http.put(`/customer/queue/${customer.id}`, {
                  customerID: customer.customerID,
                  status: customer.status,
                  notes: customer.notes,
                  position: customer.position
                })
            )

        if (updatePromises.length > 0) {
          await Promise.all(updatePromises)
        }
        load()
        return true
      } catch (error) {
        console.error('Error saving queue:', error)
        return false
      }
    }

    // Add a new customer to the queue
    const addToList = async (): Promise<void> => {
      if (!selectedCustomer.value) return

      try {
        // Set position to be at the end of the active queue
        const position = activeCustomers.value.length

        const newQueueItem = await http.post<CustomerQueue>('/customer/queue', {
          customerID: selectedCustomer.value.id,
          status: 'active', // Active status
          notes: '',
          position: position // Add position field
        })

        activeCustomers.value.push({
          ...newQueueItem,
          createdAt: new Date()
        })

        // Reset form
        selectedCustomer.value = null
      } catch (error) {
        console.error('Error adding customer:', error)
      }
    }

    // Start editing notes for a customer
    const startEditing = (customer: CustomerQueue): void => {
      editingCustomer.value = {...customer}

      // Focus the textarea after it's rendered
      nextTick(() => {
        if (notesTextarea.value) {
          notesTextarea.value.focus()
        }
      })
    }

    // Save edited notes
    const saveNotes = async (customer: CustomerQueue): Promise<void> => {
      if (!editingCustomer.value) return

      try {
        // First update notes on the backend
        await http.put(`/customer/queue/${customer.id}`, {
          customerID: customer.customerID,
          status: customer.status,
          notes: editingCustomer.value.notes,
          position: customer.position
        })

        // Only update frontend state after successful backend update
        let found = false

        // Check active customers
        const activeIndex = activeCustomers.value.findIndex((c) => c.id === customer.id)
        if (activeIndex !== -1) {
          activeCustomers.value[activeIndex].notes = editingCustomer.value.notes
          found = true
        }

        // Check on-hold customers if not found in active
        if (!found) {
          const holdIndex = onHoldCustomers.value.findIndex((c) => c.id === customer.id)
          if (holdIndex !== -1) {
            onHoldCustomers.value[holdIndex].notes = editingCustomer.value.notes
          }
        }

        // Clear editing state
        editingCustomer.value = null
      } catch (error) {
        console.error('Error saving notes:', error)
        // Don't update frontend state if backend update fails
      }
    }

    // Mark a customer as on hold
    const markOnHold = async (customer: CustomerQueue): Promise<void> => {
      const index = activeCustomers.value.findIndex((c) => c.id === customer.id)
      if (index !== -1) {
        try {
          // Calculate new position at the end of on-hold queue
          const newPosition = activeCustomers.value.length + onHoldCustomers.value.length - 1

          // First update status on the backend
          await http.put(`/customer/queue/${customer.id}`, {
            customerID: customer.customerID,
            status: 'on-hold', // On hold status
            notes: customer.notes,
            position: newPosition
          })

          // Only update frontend state after successful backend update
          const updatedCustomer = {
            ...customer,
            status: 'on-hold',
            position: newPosition
          }
          activeCustomers.value.splice(index, 1)
          onHoldCustomers.value.push(updatedCustomer)

          // Save the updated queue to update positions
          await saveQueue()
        } catch (error) {
          console.error('Error marking customer on hold:', error)
          // Don't update frontend state if backend update fails
        }
      }
    }

    // Reactivate a customer from on hold
    const reactivate = async (customer: CustomerQueue): Promise<void> => {
      const index = onHoldCustomers.value.findIndex((c) => c.id === customer.id)
      if (index !== -1) {
        try {
          // Calculate new position at the end of active queue
          const newPosition = activeCustomers.value.length

          // First update status on the backend
          await http.put(`/customer/queue/${customer.id}`, {
            customerID: customer.customerID,
            status: 'active', // Active status
            notes: customer.notes,
            position: newPosition
          })

          // Only update frontend state after successful backend update
          const updatedCustomer = {
            ...customer,
            status: 'active',
            position: newPosition
          }
          onHoldCustomers.value.splice(index, 1)
          activeCustomers.value.push(updatedCustomer)

          // Save the updated queue to update positions
          await saveQueue()
        } catch (error) {
          console.error('Error reactivating customer:', error)
          // Don't update frontend state if backend update fails
        }
      }
    }

    // Mark a customer as done (remove from queue)
    const markDone = async (customer: CustomerQueue): Promise<void> => {
      try {
        // First delete from the backend
        await http.delete(`/customer/queue/${customer.id}`)

        // Only update frontend state after successful backend deletion
        let index = activeCustomers.value.findIndex((c) => c.id === customer.id)
        if (index !== -1) {
          activeCustomers.value.splice(index, 1)
        } else {
          index = onHoldCustomers.value.findIndex((c) => c.id === customer.id)
          if (index !== -1) {
            onHoldCustomers.value.splice(index, 1)
          }
        }

        // Save the updated queue to update positions of remaining items
        await saveQueue()
      } catch (error) {
        console.error('Error marking customer as done:', error)
        // Don't update frontend state if backend deletion fails
      }
    }

    // Add customer to glasses list
    const addToGlassesList = async (customer: CustomerQueue): Promise<void> => {
      if (customer.glassesJobID) {
        return
      }

      try {
        const res = await http.put<any>(`/customer/queue/${customer.id}/to-glasses-list`, {})
        customer.glassesJobID = res.id
      } catch (error) {
        console.error('Error adding customer to glasses list:', error)
      }
    }

    // Format the time for display
    const formatTime = (date: Date): string => {
      if (!date) return ''
      try {
        const d = new Date(date)
        return d.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
      } catch (error) {
        console.error('Error formatting date:', error)
        return ''
      }
    }

    const onCustomerCreater = async (customer: Customer) => {
      customerOptions.value = [...customerOptions.value, customer]
      console.log('customer', customer)
      newCustomerDialogVisiable.value = false

      // Directly add the new customer to the list
      try {
        const position = activeCustomers.value.length

        const newQueueItem = await http.post<CustomerQueue>('/customer/queue', {
          customerID: customer.id,
          status: 'active',
          notes: '',
          position: position
        })

        activeCustomers.value.push({
          ...newQueueItem,
          createdAt: new Date()
        })
      } catch (error) {
        console.error('Error adding customer:', error)
      }
    }

    // Watch for customer selection and automatically add to list
    watch(selectedCustomer, (newCustomer) => {
      if (newCustomer) {
        addToList()
      }
    })

    function onOrderCreated(o: Order) {
      console.log('order created', o)
      load();
    }

    function addCustomer(customer: Customer) {
      emit('addCustomer', customer)
    }

    return {
      t,
      activeCustomers,
      onHoldCustomers,
      addToList,
      markOnHold,
      reactivate,
      markDone,
      addToGlassesList,
      formatTime,
      saveQueue,
      editingCustomer,
      startEditing,
      saveNotes,
      notesTextarea,
      loading,
      customerOptions,
      selectedCustomer,
      remoteSearch,
      newCustomerDialogVisiable,
      onCustomerCreater,
      onOrderCreated,
      addCustomer,
      useSettingsStore
    }
  }
})
</script>
